import React from "react";
import { withStyles } from "@material-ui/core";
import { get, map } from "lodash";

import Box from "@material-ui/core/Box";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = {
  iconContainer: {
    width: "40px",
    height: "40px",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "@media print": {
      display: "none",
    },
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
  menuItem: {
    padding: "15px 30px",
    fontSize: "1em",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
};

const AddIcon = (props) => {
  const {
    classes,
    handleClick,
    disabled,
    subMenu,
    labelField,
    handleSubMenuSelect,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  return (
    <Box className={classes.iconContainer}>
      <img
        src={disabled ? images.plusIconGrey : images.plusIconColored}
        alt="add"
        onClick={(e) => disabled ? console.log("disabled") : 
          subMenu ? setAnchorEl(e.currentTarget) : handleClick()
        }
        aria-controls="simple-menu"
        aria-haspopup="true"
      />
      {subMenu && (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          getContentAnchorEl={null}
        >
          {map(subMenu, (item, index) => (
            <MenuItem
              key={index}
              classes={{ root: classes.menuItem }}
              alignItems="center"
              onClick={() => {
                setAnchorEl(null);
                handleSubMenuSelect(item);
              }}
              style={{ paddingLeft: "0px !important" }}
            >
              {get(item, [labelField])}
            </MenuItem>
          ))}
        </Menu>
      )}
    </Box>
  );
};

export default withStyles(styles)(AddIcon);
